module.exports = "<div class=\"container-fluid ui-g-nopad\">\n  <div class=\"ui-g-12\" style=\"padding:0;margin: 0; width:100%\">\n    <nav></nav>\n  </div>\n  <div class=\"ui-g-12\">\n    <router-outlet></router-outlet>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main